import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  avatarContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2)
  },
  largeAvatar: {
    width: theme.spacing(50), // Aumenta o tamanho do avatar
    height: theme.spacing(50), // Aumenta o tamanho do avatar
    marginBottom: theme.spacing(2),
    borderRadius: '0'
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: theme.spacing(2)
  },
  refreshButton: {
    backgroundColor: theme.palette.blue_300.main,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    '&:disabled': {
      backgroundColor: theme.palette.grey[400],
    }
  },
  closeButton:{
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center'
  }
}))
